import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { HourglassMedium, XCircle } from "@phosphor-icons/react";

export default function PendingApproval() {
  const { user, loading, logout, refetch } = useAuth();
  const navigate = useNavigate();
  const rejected = user?.status === "rejected";

  useEffect(() => {
    if (!loading && !user) navigate("/login", { replace: true });
    if (!loading && user?.status === "active") navigate("/", { replace: true });
  }, [loading, user, navigate]);

  const checkAgain = async () => { await refetch(); };
  const handleLogout = async () => { await logout(); navigate("/login"); };

  if (loading || !user || user.status === "active") return null;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-4" data-testid="pending-approval-page">
      <div className="w-full max-w-sm card-flat p-8 text-center">
        {rejected ? (
          <XCircle size={40} className="text-destructive mx-auto mb-4" />
        ) : (
          <HourglassMedium size={40} className="text-accent mx-auto mb-4" />
        )}
        <h1 className="font-display font-extrabold text-lg mb-2">{rejected ? "Access Denied" : "Awaiting Approval"}</h1>
        <p className="text-sm text-muted-foreground mb-1" data-testid="pending-approval-user-email">{user.email}</p>
        <p className="text-sm text-muted-foreground mb-6">
          {rejected
            ? "Your access request was declined. Contact your admin if you believe this is a mistake."
            : "You've signed in successfully, but an admin still needs to approve your access. Check back soon."}
        </p>
        {!rejected && (
          <button data-testid="pending-approval-check-again-btn" onClick={checkAgain} className="btn-outline-navy w-full mb-3">
            Check Again
          </button>
        )}
        <button data-testid="pending-approval-signout-btn" onClick={handleLogout} className="btn-navy w-full">Sign Out</button>
      </div>
    </div>
  );
}
